// @flow

/*
 * This is an animation timing function. It takes the percentage of time through the animation, and returns
 * the percentage of the change for that given time. For example, if we were 5 seconds through a 10
 * second animation, `t` would be `0.5`. For a linear animation, the returned value would also be 0.5 as we
 * are exactly half way through the animation. This can be replaced by several different functions to create
 * different effects. See https://gist.github.com/gre/1650294 for other simple examples
 */
const easeInOutQuad = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);

const doScroll = (startTime, startValue, distance, duration) => {
  window.requestAnimationFrame((now) => {
    const t = (now - startTime) / duration;
    if (t >= 1) {
      window.scrollTo(0, startValue + distance);
      return;
    }
    const change = easeInOutQuad(t);
    window.scrollTo(0, startValue + change * distance);
    doScroll(startTime, startValue, distance, duration);
  });
};

const smoothScrollDown = (el, duration) => {
  const initialScrollOffset = window.pageYOffset;
  const targetScrollOffset =
    initialScrollOffset + el.getBoundingClientRect().top;
  const distance = targetScrollOffset - initialScrollOffset;
  const startTime = performance.now();
  doScroll(startTime, initialScrollOffset, distance, duration);
};

const addScrollHandler = () => {
  const scrollDownButton = document.getElementById("hero-scroll-down");
  const destination = document.getElementById("scroll-destination");
  if (scrollDownButton && destination) {
    scrollDownButton.addEventListener("click", () => {
      smoothScrollDown(destination, 500);
    });
  }
};

export default addScrollHandler;
